"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _intl = require("@myci/intl");
var _ramda = require("ramda");
var _IntlNavigationProvider = _interopRequireDefault(require("./IntlNavigationProvider"));
var _jsxRuntime = require("react/jsx-runtime");
var getIntl = (0, _ramda.path)(['pageContext', 'intl']);

/* eslint-disable react/display-name,react/prop-types */
var _default = exports.default = function _default(_ref) {
  var element = _ref.element,
    props = _ref.props;
  var intl = getIntl(props);
  if (!intl) {
    return element;
  }
  if (typeof window !== 'undefined') {
    window.___gatsbyIntl = intl;
  }
  var locale = intl.locale,
    defaultLocale = intl.defaultLocale,
    initialIntlOptions = intl.intlOptions,
    initialMessages = intl.messages,
    initialNamespaces = intl.namespaces;
  var pluginContextValue = {
    defaultLocale: defaultLocale,
    initialNamespaces: initialNamespaces
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_intl.IntlProvider, {
    initialMessages: initialMessages,
    initialLocale: locale,
    initialNamespaces: initialNamespaces,
    initialIntlOptions: initialIntlOptions,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_IntlNavigationProvider.default, {
      value: pluginContextValue,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_intl.TranslationModeProvider, {
        children: element
      })
    })
  });
};